import { Component, Inject, OnInit, Optional, ViewChild } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatPaginator,
  MatSort,
  MatTableDataSource,
} from "@angular/material";
import { TransformerManagerService } from "../services/transformerManager.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { HttpClient } from "@angular/common/http";
import pdfMake from "pdfmake/build/pdfmake";
import { DatePipe } from "@angular/common";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import * as moment from "moment";
import { CustomDateComponent } from "../reports/customdate/custom-date.component";
@Component({
  selector: 'app-penalty',
  templateUrl: './penalty.component.html',
  styleUrls: ['./penalty.component.scss']
})
export class PenaltyComponent implements OnInit {

  idFilter: string = "";
  unitCost: number;
  timeFilter: string;
  filter: any = {};
  downloadMessage = "Downloading...";
  data: any;
  sitename: any = [];
  dataSource;
  totalPenalty: number = 0;
  selectedSite: any;
  transformerId: any = [];
  timeOptions: string[] = [
    "Today",
    "Yesterday",
    "This Week",
    "This Month",
    "Last Month",
    "Custom",
  ];
  selectedId: string = "";
  city: string;
  location: string;
  showAlert: boolean = false;
 
  preferredColumns: string[] = [
    "reading_time",
    "transformer_id",
    "actual_pf",
    "threshold_pf",
    "penalty",
    "loadPercentage",
    "Average_Voltage",
    "R_Ph_N",
    "Y_Ph_N",
    "B_Ph_N",
    "L1",
    "L2",
    "L3",
    "LN",
   "System_kwh"
  ];
  reportColumns: any;
  ddlData: any = [];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  alertMessage: string;
  customeSelectedDate: any;
  constructor(
    private http: HttpClient,
    @Optional() @Inject(MAT_DIALOG_DATA) public injectedTransformerId: any,
    private datePipe: DatePipe,
    private matDialog: MatDialog,
    private transMngSer: TransformerManagerService,
    private ngxLoader: NgxUiLoaderService
  ) {}

  async ngOnInit() {
    this.transformerId = await this.getDdlData();
    
    this.sitename = this.ddlData.map((a) => a.sitename);
    if (this.transformerId.length > 0) {
      this.timeFilter = "Today";
      const defaultValue = this.transformerId[0];
      this.filters("transformerId", defaultValue);
      this.filters("date", "Today");
    }
    if (this.injectedTransformerId) {
      this.filters("transformerId", this.injectedTransformerId);
    }
  }

  getDdlData() {
    this.transMngSer
      .getTransformerData(
        JSON.parse(localStorage.getItem("userData")).roleid,
        JSON.parse(localStorage.getItem("userData")).userid,
        "report"
      )
      .toPromise()
      .then((response: any) => {
        console.log("DDL:", response.data);
        if (response.data.length > 0) {
          this.ddlData = response.data;
          this.transformerId = this.ddlData.map((item: any) => ({
            serialnumber: item.serialnumber,
            sitename: item.sitename,
          }));
          this.idFilter = this.transformerId[0].serialnumber;
        } else {
          this.transformerId = [];
        }
      });
  }

  getHeaderName(col: string): string {
    switch (col) {
      case "transformer_id":
        return "Transformer Id";
      case "site_name":
        return "Site Name";
      case "reading_time":
        return "Timestamp";
      case "actual_pf":
        return "Actual PF";
      case "threshold_pf":
        return "Threshold PF";
      case "loadPercentage":
        return "Load (%)";
      case "penalty":
        return "Penalty";
      case "Average_Voltage":
        return "Average Voltage (V)";
      case "R_Ph_N":
        return "R-N Voltage (V)";
      case "Y_Ph_N":
        return "Y-N Voltage (V)";
      case "B_Ph_N":
        return "B-N Voltage (V)";
      case "RY_Voltage":
        return "R-Y Voltage (V)";
      case "YB_Voltage":
        return "Y-B Voltage (V)";
      case "BR_Voltage":
        return "B-R Voltage (V)";
      case "L1":
        return "R - Current (A)";
      case "L2":
        return "Y - Current (A)";
      case "L3":
        return "B - Current (A)";
      case "LN":
        return "N - Current (A)";
        case "System_kwh":
                return "Active(kWh)";
      default:
        return col;
    }
  }

  generateReport() {
    if (!this.unitCost) {
      this.showAlert = true;
      this.alertMessage = "Please enter the Unit Cost before proceeding.";
      return;
    }
    if (!this.timeFilter) {
      this.showAlert = true;
      this.alertMessage = 'Please select a Duration before proceeding.';
      return;
    }
    this.totalPenalty = 0;
    this.ngxLoader.start();
    const requestData: any = {
      transformerId: this.idFilter,
      unitCost: this.unitCost,
    };
    if (this.filter.filter) requestData.filter = this.filter.filter;
    if (this.filter.date) requestData.date = this.filter.date;
    if (this.filter.startDate) requestData.startDate = this.filter.startDate;
    if (this.filter.endDate) requestData.endDate = this.filter.endDate;
    console.log("Payload being sent:", requestData);
    this.transMngSer.pfPenalty(requestData).subscribe({
      next: (response: any) => {
        console.log("Backend response:", response);
        if (response.data && response.data.length > 0) {
          this.data = response.data.map((item: any) => {
            if (item.reading_time) {
              item.reading_time = this.datePipe.transform(
                item.reading_time,
                "dd-MM-yyyy HH:mm:ss"
              );
            }
            return item;
          });
          this.data = response.data;
          this.reportColumns = this.preferredColumns.filter((col) =>
            Object.keys(this.data[0]).includes(col)
          );
          this.dataSource = new MatTableDataSource(this.data);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.totalPenalty = this.data.reduce(
            (sum, item) => sum + (Number(item.penalty) || 0),
            0
          );
        } else {
          this.data = [];
          this.dataSource = new MatTableDataSource([]);
          this.totalPenalty = 0;
        }
        this.ngxLoader.stop();
      },
      error: (err) => {
        console.error("Error:", err);
        this.totalPenalty = 0;
        this.dataSource = new MatTableDataSource([]);
        this.reportColumns = [];
        this.ngxLoader.stop();
      },
    });
  }

  closeAlert() {
    this.showAlert = false;
  }

  async filters(type: string, value: any) {
    console.log(type, value);
    if (type === "transformerId") {
      this.idFilter = value.split("[")[0];
      this.filter.transformerId = this.idFilter;
      this.selectedId = value;
      this.selectedSite = this.ddlData.filter(
        (a) => a.serialnumber === this.idFilter
      );
      if (this.selectedSite.length > 0) {
        this.city = this.selectedSite[0].City;
        this.location = this.selectedSite[0].Location;
        this.selectedSite = this.selectedSite[0].sitename;
      }
    }
    if (type === "date") {
      this.timeFilter = value;
      var filter: any = await this.formatDate(value);
      if (
        filter.filter === "This Week" ||
        filter.filter === "This Month" ||
        filter.filter === "Last Month"
      ) {
        if (this.filter && this.filter.date) {
          delete this.filter.date;
        }
        this.filter.startDate = filter.startDate;
        this.filter.endDate = filter.endDate;
        this.filter.filter = filter.filter;
      } else if (filter.filter === "Today" || filter.filter === "Yesterday") {
        if (this.filter && this.filter.startDate && this.filter.endDate) {
          delete this.filter.startDate;
          delete this.filter.endDate;
        }
        this.filter.date = filter.date;
        this.filter.filter = filter.filter;
      } else if (filter.filter === "Custom") {
        if (this.filter && this.filter.date) {
          delete this.filter.date;
        }
        if (filter.startDate && filter.endDate) {
          this.filter.startDate = filter.startDate;
          this.filter.endDate = filter.endDate;
          this.filter.filter = filter.filter;
        }
      }
      if (filter.startDate && filter.endDate) {
      }
    }
  }
  formatDate(value) {
    return new Promise((resolve, reject) => {
      if (value === "Today") {
        var d = new Date(),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        resolve({ date: [year, month, day].join("-"), filter: value });
      } else if (value === "Yesterday") {
        var d = new Date(),
          month = "" + (d.getMonth() + 1),
          day = "" + (d.getDate() - 1),
          year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        resolve({ date: [year, month, day].join("-"), filter: value });
      } else if (value === "Last Month") {
        resolve({
          startDate: moment()
            .subtract(1, "months")
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: moment()
            .subtract(1, "months")
            .endOf("month")
            .format("YYYY-MM-DD"),
          filter: value,
        });
      } else if (value === "This Month") {
        resolve({
          startDate: moment().startOf("month").format("YYYY-MM-DD"),
          endDate: moment().endOf("month").format("YYYY-MM-DD"),
          filter: value,
        });
      } else if (value === "This Week") {
        resolve({
          startDate: moment().startOf("week").format("YYYY-MM-DD"),
          endDate: moment().endOf("week").format("YYYY-MM-DD"),
          filter: value,
        });
      } else if (value === "Custom") {
        console.log("Custom filter:", value);
        const dialogConfig = new MatDialogConfig();
        let dialogRef = this.matDialog.open(CustomDateComponent, {
          autoFocus: false,
          height: "350px",
          width: "450px",
          data: {
            details: "",
            action: "Add",
            selectedDate: this.customeSelectedDate,
          },
        });
        dialogRef.afterClosed().subscribe((selectedDate) => {
          this.customeSelectedDate = selectedDate;
          if (selectedDate && selectedDate.startDate && selectedDate.endDate) {
            resolve({
              startDate: selectedDate.startDate,
              endDate: selectedDate.endDate,
              filter: "Custom",
            });
          }
        });
      }
    });
  }

  formatData(data) {
    return new Promise((resolve, reject) => {
      var dataArr = [];
      dataArr.push(this.reportColumns);
      data.forEach((element) => {
        delete element.City;
        delete element.Location;
        dataArr.push(Object.values(element));
      });
      resolve(dataArr);
    });
  }

  exportToExcel() {
    const sheetData = this.formatDataForExport();
    if (sheetData.length === 0) {
      console.warn("No data to export");
      return;
    }
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(sheetData);
    const workbook: XLSX.WorkBook = {
      SheetNames: ["Penalty Report"],
      Sheets: { "Penalty Report": worksheet },
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob: Blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    FileSaver.saveAs(blob, `${this.idFilter || "Penalty_Report"}.xlsx`);
  }

  formatDataForExport(): any[][] {
    if (!this.data || !this.reportColumns || this.data.length === 0) return [];
    const header = this.reportColumns.map((col) => this.getHeaderName(col));
    const rows = this.data.map((row) =>
      this.reportColumns.map((col) => (row[col] !== undefined ? row[col] : ""))
    );
    return [header, ...rows];
  }

  exportToPdf() {
    const sheetData = this.formatDataForExport();
    if (sheetData.length === 0) {
      console.warn("No data to export");
      return;
    }
    const docDefinition = {
      info: { title: "Transformer Penalty Report" },
      pageOrientation: "landscape",
      pageSize: "A4",
      content: [
        {
          text: "Transformer Penalty Report",
          style: "header",
          margin: [0, 0, 0, 10],
        },
        {
          table: {
            headerRows: 1,
            widths: Array(sheetData[0].length).fill("*"),
            body: sheetData,
          },
        },
      ],
      styles: {
        header: { fontSize: 16, bold: true, alignment: "center" },
      },
    };
    pdfMake
      .createPdf(docDefinition)
      .download(`${this.idFilter || "Penalty_Report"}.pdf`);
  }

  refreshData() {
    console.log("Refreshing data...");
    this.generateReport();
  }
//   refreshData() {
//   console.log("Refreshing & reloading data...");

//   // clear table
//   this.data = [];
//   this.dataSource = new MatTableDataSource([]);
//   this.totalPenalty = 0;
//   this.reportColumns = [];

//   // reset filter to defaults
//   this.filter = {};
//   this.unitCost = null;

//   if (this.transformerId.length > 0) {
//     this.timeFilter = "Today";
//     this.idFilter = this.transformerId[0].serialnumber;
//     this.filters("transformerId", this.idFilter);
//     this.filters("date", "Today");
//   }
// }
}
